import React from 'react';
import PropTypes from 'prop-types';
import ArrowRight from 'dibs-vg/dist/react/arrow-right';

// components
import { FormattedMessage } from 'react-intl';

// styles
import styles from './PdpRespHeroCarouselViewInRoom.scss';

export const PdpRespHeroCarouselViewInRoom = props => {
    const { onClick } = props;

    return (
        <div
            className={styles.container}
            onClick={onClick}
            style={{
                backgroundImage: `url('https://a.1stdibscdn.com/cdnmisc/roomimages/black-white-template.jpg')`,
            }}
        >
            <div className={styles.wrapper}>
                <div className={styles.header}>
                    <FormattedMessage
                        id="PdpRespHeroCarouselViewInRoom.viewInRoomHeader"
                        defaultMessage="See this artwork in context"
                    />
                </div>
                <a className={styles.link}>
                    <FormattedMessage
                        id="PdpRespHeroCarouselViewInRoom.viewInRoom"
                        defaultMessage="View In Room"
                    />
                    <ArrowRight className={styles.arrow} />
                </a>
            </div>
        </div>
    );
};

PdpRespHeroCarouselViewInRoom.defaultProps = {
    onClick: () => {},
};

PdpRespHeroCarouselViewInRoom.propTypes = {
    onClick: PropTypes.func,
};

export default PdpRespHeroCarouselViewInRoom;
